import { range } from "@shared/common/utils/range";
import {
  CutLineStrategy,
  CutLineStrategyPartWithContext,
} from "@opstel/geo/GetLinePartsStrategies/CutLineStrategy";
import { IPath } from "@opstel/geo/IPath";
import { Path } from "@opstel/geo/Path";
import { Point } from "@opstel/geo/Point";

type IsTrainOrGap = {
  type: "train" | "gap";
};

export function getUnitPaths(trackLineWidth: number, points: Point[], units: number): IPath[] {
  const trainUnitWidth: CutLineStrategyPartWithContext<IsTrainOrGap> = {
    type: "*",
    context: {
      type: "train",
    },
  };
  const gapSize = 2 * trackLineWidth;
  const gapWidth: CutLineStrategyPartWithContext<IsTrainOrGap> = {
    type: "px",
    value: gapSize,
    context: {
      type: "gap",
    },
  };

  const parts = range(2 * units - 1).map((i) => (i % 2 === 0 ? trainUnitWidth : gapWidth));

  const strategy = new CutLineStrategy(parts);
  const path = new Path(points);
  const pathSegments = path.getPathSegments(strategy, (ctx) => ctx?.type === "train");
  return pathSegments.map((p) => p.path);
}
